function roundedRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

function drawBackground(ctx, W, H, art) {
  if (art) {
    const s = Math.max(W / art.width, H / art.height);
    const w = art.width * s, h = art.height * s;
    ctx.drawImage(art, (W - w) / 2, (H - h) / 2, w, h);
    // darken for legibility: strong on the left/center where text sits, lighter on the right
    const shade = ctx.createLinearGradient(0, 0, W, 0);
    shade.addColorStop(0, "rgba(12,13,14,0.88)");
    shade.addColorStop(0.55, "rgba(12,13,14,0.72)");
    shade.addColorStop(1, "rgba(12,13,14,0.35)");
    ctx.fillStyle = shade; ctx.fillRect(0, 0, W, H);
    const bottom = ctx.createLinearGradient(0, H * 0.6, 0, H);
    bottom.addColorStop(0, "rgba(12,13,14,0)"); bottom.addColorStop(1, "rgba(12,13,14,0.85)");
    ctx.fillStyle = bottom; ctx.fillRect(0, 0, W, H);
    return;
  }
  const grad = ctx.createLinearGradient(0, 0, W, H);
  grad.addColorStop(0, "#0C0D0E");
  grad.addColorStop(1, "#141618");
  ctx.fillStyle = grad; ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W * 0.8, -100, 20, W * 0.8, -100, 700);
  glow.addColorStop(0, "rgba(0,230,118,0.28)"); glow.addColorStop(1, "rgba(0,230,118,0)");
  ctx.fillStyle = glow; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "rgba(255,255,255,0.04)";
  for (let x = 40; x < W; x += 40) for (let y = 40; y < H; y += 40) { ctx.beginPath(); ctx.arc(x, y, 1, 0, Math.PI * 2); ctx.fill(); }
}

function drawLogo(ctx, x, y, size) {
  ctx.fillStyle = "#00E676";
  roundedRect(ctx, x, y, size, size, size * 0.22);
  ctx.fill();
  ctx.fillStyle = "#001b09";
  ctx.font = `900 ${Math.round(size * 0.72)}px 'Cabinet Grotesk', 'Liberation Sans', Arial, sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("C", x + size / 2, y + size / 2 + size * 0.03);
  ctx.textAlign = "start";
  ctx.textBaseline = "alphabetic";
}

function drawHeadline(ctx, refund) {
  drawLogo(ctx, 80, 68, 56);
  ctx.fillStyle = "#00E676";
  ctx.font = "600 22px 'JetBrains Mono', monospace";
  ctx.fillText("CLAWBACK · MONEY-RECOVERY AGENT", 152, 104);
  ctx.fillStyle = "#F4F1EA";
  ctx.font = "600 34px 'JetBrains Mono', monospace";
  ctx.fillText("I JUST CLAWED BACK", 80, 260);
  ctx.fillStyle = "#00E676";
  ctx.font = "800 260px 'Cabinet Grotesk', 'Clash Display', sans-serif";
  ctx.fillText(`$${refund.amount.toFixed(2)}`, 70, 500);
  ctx.fillStyle = "#A0A7B0";
  ctx.font = "500 38px 'Plus Jakarta Sans', sans-serif";
  ctx.fillText(`from ${refund.merchant}`, 80, 570);
}

function drawFooter(ctx, refund, W) {
  ctx.strokeStyle = "#282C30"; ctx.lineWidth = 2;
  if (ctx.setLineDash) ctx.setLineDash([8, 8]);
  ctx.beginPath(); ctx.moveTo(80, 640); ctx.lineTo(W - 80, 640); ctx.stroke();
  if (ctx.setLineDash) ctx.setLineDash([]);
  ctx.fillStyle = "#606872"; ctx.font = "500 24px 'JetBrains Mono', monospace";
  ctx.fillText(`VIA ${(refund.channel || "").toUpperCase().replace(/_/g, " ")}`, 80, 700);
  ctx.fillStyle = "#F4F1EA"; ctx.font = "600 36px 'Plus Jakarta Sans', sans-serif";
  ctx.fillText("Refund landed. No bank password required.", 80, 760);
  const boxY = 830;
  ctx.fillStyle = "#141618"; ctx.strokeStyle = "#00E676"; ctx.lineWidth = 2;
  roundedRect(ctx, 80, boxY, W - 160, 150, 12);
  ctx.fill(); ctx.stroke();
  drawLogo(ctx, W - 80 - 24 - 96, boxY + 27, 96);
  ctx.fillStyle = "#606872"; ctx.font = "500 20px 'JetBrains Mono', monospace";
  ctx.fillText("YOUR TURN — REFUNDBOT.ORG", 110, boxY + 40);
  ctx.fillStyle = "#F4F1EA"; ctx.font = "700 42px 'Cabinet Grotesk', sans-serif";
  ctx.fillText("Find your leaks.", 110, boxY + 100);
  ctx.fillStyle = "#00E676"; ctx.font = "500 22px 'JetBrains Mono', monospace";
  ctx.fillText("$12.99 / month · 0% of your payout", 110, boxY + 130);
}

// Renders the 1080x1080 share card onto the canvas and returns a PNG data URL
export function drawShareCard(canvas, refund, art = null) {
  const ctx = canvas.getContext("2d");
  const W = 1080, H = 1080;
  canvas.width = W; canvas.height = H;
  drawBackground(ctx, W, H, art);
  drawHeadline(ctx, refund);
  drawFooter(ctx, refund, W);
  return canvas.toDataURL("image/png");
}
